import { render, staticRenderFns } from "./selectAdvantage.vue?vue&type=template&id=a78ce02c&scoped=true"
import script from "./selectAdvantage.vue?vue&type=script&lang=js"
export * from "./selectAdvantage.vue?vue&type=script&lang=js"
import style0 from "./selectAdvantage.vue?vue&type=style&index=0&id=a78ce02c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a78ce02c",
  null
  
)

export default component.exports